import type { ProviderKind } from "@cmmd-forge/contracts";

import type { ComposerCommandItem } from "./ComposerCommandMenu";
import { isSubscriptionProvider } from "./composerPlanUsage";

const BUILT_IN_COMPOSER_SLASH_COMMAND_ITEMS = [
  {
    id: "slash:model",
    type: "slash-command",
    command: "model",
    label: "/model",
    description: "Switch response model for this thread",
  },
  {
    id: "slash:plan",
    type: "slash-command",
    command: "plan",
    label: "/plan",
    description: "Switch this thread into plan mode",
  },
  {
    id: "slash:default",
    type: "slash-command",
    command: "default",
    label: "/default",
    description: "Switch this thread back to normal build mode",
  },
  {
    id: "slash:usage-limits",
    type: "slash-command",
    command: "usage-limits",
    label: "/usage-limits",
    description: "Show current account usage limits",
  },
] satisfies ReadonlyArray<Extract<ComposerCommandItem, { type: "slash-command" }>>;

export function builtInComposerSlashCommandItems(
  provider: ProviderKind,
): ReadonlyArray<Extract<ComposerCommandItem, { type: "slash-command" }>> {
  return BUILT_IN_COMPOSER_SLASH_COMMAND_ITEMS.filter(
    (item) => item.command !== "usage-limits" || isSubscriptionProvider(provider),
  );
}
